export const inputClasses = {
  base: 'w-full rounded-lg border pr-10 focus:ring-2 cursor-pointer bg-white text-left',
  size: {
    sm: 'text-sm px-3 py-2',
    md: 'text-base px-4 py-2',
    lg: 'text-lg px-5 py-3',
  },
  status: {
    error: 'border-red-500 focus:ring-red-500',
    success: 'border-gray-300 focus:ring-blue-500',
    disabled: 'cursor-not-allowed opacity-50',
    enabled: 'cursor-pointer',
  },
}
